// Centralised icon resolver for dashboard KPI / attention / lifecycle / funnel tiles.
// Pure mapping — never alters numbers, counts, statuses, or layout.
import {
  TrendingUp, WalletCards, ReceiptText, Gauge,
  FileWarning, UserCog, TimerOff, LockKeyhole, FileClock,
  UserPlus, FileText, Users, FolderOpen, Send, ShieldCheck, Receipt, BadgeDollarSign,
  Filter, Trophy, FileCheck,
  Activity,
} from "lucide-react";

// ---- KPI icons --------------------------------------------------------------
const KPI = {
  revenue:        TrendingUp,
  collections:    WalletCards,
  cash:           WalletCards,
  outstanding_ar: ReceiptText,
  outstanding:    ReceiptText,
  ar:             ReceiptText,
  gross_margin:   Gauge,
  margin:         Gauge,
};

export function getKpiIcon(metricKey) {
  const k = (metricKey || "").toLowerCase().replace(/[\s-]+/g, "_");
  return KPI[k] || Activity;
}

// ---- Attention icons --------------------------------------------------------
const ATTENTION = {
  quotes_over_limit:        FileWarning,
  override_requests:        UserCog,
  sla_breached:             TimerOff,
  payment_blocked_outputs:  LockKeyhole,
  client_docs_overdue:      FileClock,
};

export function getAttentionIcon(cardKey) {
  const k = (cardKey || "").toLowerCase().replace(/[\s-]+/g, "_");
  return ATTENTION[k] || FileWarning;
}

// ---- Lifecycle / funnel icons -----------------------------------------------
const STAGE = {
  lead:        UserPlus,
  mql:         Filter,
  qualified:   Filter,
  quotation:   FileText,
  quoted:      FileText,
  customer:    Users,
  case_open:   FolderOpen,
  case:        FolderOpen,
  open:        FolderOpen,
  submission:  Send,
  approval:    ShieldCheck,
  won:         Trophy,
  negotiation: Trophy,
  invoice:     Receipt,
  invoiced:    FileCheck,
  receipt:     BadgeDollarSign,
  paid:        BadgeDollarSign,
  collected:   BadgeDollarSign,
};

function normalizeStage(value) {
  if (!value) return "";
  let s = typeof value === "string" ? value : (value.key || value.label || value.name || "");
  return s.toString().trim().toLowerCase().replace(/[\s/]+/g, "_").replace(/[^a-z0-9_]/g, "");
}

export function getLifecycleStageIcon(stage) {
  return STAGE[normalizeStage(stage)] || Activity;
}

export const getFunnelStageIcon = getLifecycleStageIcon;

// ---- Tone color mapping (shared with statusTheme/dashboardColors) -----------
const TONE_TO_HEX = {
  red:    "#EF4444",
  amber:  "#F59E0B",
  orange: "#F97316",
  green:  "#10B981",
  blue:   "#2563EB",
  teal:   "#0891B2",
  slate:  "#64748B",
};

export function getDashboardIconColor(key, tone) {
  if (tone && TONE_TO_HEX[tone]) return TONE_TO_HEX[tone];
  return TONE_TO_HEX.slate;
}
